<template>
  <div class="order-info" style="width: 100%">
    <el-row :gutter="23" style="border:1px solid #000">
      <!-- 订单信息 -->
      <el-col :span="13" style="border-right:1px dashed #000; height: 100%">
        <el-form :disabled="disabled" @submit.native.prevent>
          <el-row :gutter="20">
            <el-col :span="8">
              <div style="width: 200px">
                <el-form-item label="业务员" required>
                  <el-select v-model="order.salesman" @focus="getSalesMen">
                    <template v-for="salesman in salesmen">
                      <el-option :label="salesman.realName" :value="salesman.username"></el-option>
                    </template>
                  </el-select>
                </el-form-item>
                <el-form-item label="订单类别" required>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="选择订单类别，（其它）选项请用文字说明。打样与赠送客户订单需要销售主管签字"
                    placement="bottom-end"
                  >
                    <el-select v-model="order.orderType">
                      <el-option label="正常订单" value="A"></el-option>
                      <el-option label="打样" value="B"></el-option>
                      <el-option label="赠送" value="C"></el-option>
                      <el-option label="其他, 见备注" value="D"></el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="加工类别" required>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="注明是印刷还是模切订单"
                    placement="bottom-end"
                  >
                    <el-select v-model="order.type">
                      <el-option label="模切" value="C"></el-option>
                      <el-option label="印刷" value="P"></el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="对稿方式" required>
                  <el-tooltip class="item" effect="dark" content="如果没有请填写无" placement="bottom-end">
                    <el-select v-model="order.compare">
                      <el-option label="样品" value="S"></el-option>
                      <el-option label="黑稿" value="B"></el-option>
                      <el-option label="无" value="N"></el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="内卷/外卷" required>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="外卷指标签在外或打印刷面在外，内卷指底纸在外"
                    placement="bottom-end"
                  >
                    <el-select v-model="order.roll">
                      <el-option label="外卷" value="O"></el-option>
                      <el-option label="内卷" value="I"></el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="8">
              <div style="width: 200px">
                <el-form-item label="交货日期" required value-format="yyyy-MM-dd">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="指从弘丰印务发出货物的日期"
                    placement="bottom-end"
                  >
                    <el-date-picker
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期"
                      v-model="order.deliveryTime"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="订单数量(卷)" required>
                  <el-tooltip class="item" effect="dark" content="订单卷数" placement="bottom-end">
                    <el-input-number v-model="order.quantity" :precision="1" :step="0.1" :min="0"></el-input-number>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="PCS/卷" required>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="每一卷张数或每一叠张数"
                    placement="bottom-end"
                  >
                    <el-input-number
                      v-model="order.numberOfRoll"
                      :precision="1"
                      :step="0.1"
                      :min="0"
                    ></el-input-number>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="颜色参照" required>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="模切订单写无，印刷订单请选择需要印刷的标签颜色按哪个，电脑色指CMYK值，其它选项请用文字表述"
                    placement="bottom-end"
                  >
                    <el-select v-model="order.color">
                      <el-option label="样品" value="S"></el-option>
                      <el-option label="彩稿" value="P"></el-option>
                      <el-option label="电脑" value="C"></el-option>
                      <el-option label="其他" value="O"></el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="成品轴芯内径(mm)" required>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="大轴芯：76MM 中轴芯：40MM 小轴芯：25MM"
                    placement="bottom-end"
                  >
                    <el-input-number
                      v-model="order.paperElementD"
                      :precision="0"
                      :step="1"
                      :min="1"
                    ></el-input-number>
                  </el-tooltip>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="8">
              <div style="width: 200px">
                <el-form-item label="包装要求" required>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="如没有特殊要求请写（常规）有要求请用文字表述。如果此处位置不够填写请在下方备注处注明"
                    placement="bottom-end"
                  >
                    <el-input v-model="order.packing"></el-input>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="卷/箱" required>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="要求每一箱装多少卷，如果没有要求写常规"
                    placement="bottom-end"
                  >
                    <el-input v-model="order.rollOfPacking"></el-input>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="印刷内容" required>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="印刷订单注明印刷产品名称，模切订单填写无"
                    placement="bottom-end"
                  >
                    <el-input v-model="order.printInfo"></el-input>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="轴芯材质">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="轴芯的材质, 可以为空"
                    placement="bottom-end"
                  >
                    <el-input v-model="order.paperElementM"></el-input>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="UL标识:" style="margin-top:50px">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="UL要求, 若没有选择否"
                    placement="bottom-end"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="如果没有请填选否"
                      placement="bottom-end"
                    >
                      <el-checkbox v-model="order.UL" style="margin-left:10px">有</el-checkbox>
                    </el-tooltip>
                  </el-tooltip>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="出标方向" required>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="标签出纸方向，模切订单与没有特别要求的订单选择无要求，印刷订单与异形模切订单在下方样品粘贴处用箭头标明"
                  placement="bottom-end"
                >
                  <el-select v-model="order.orientation">
                    <el-option label="正出" value="N"></el-option>
                    <el-option label="反出" value="U"></el-option>
                    <el-option label="按图上箭头标注为准" value="M"></el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="备注">
                <el-input type="textarea" v-model="order.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>

      <!-- 标签信息 -->
      <el-col :span="11">
        <el-form
          :disabled="disabled"
          style="margin-left: 8px"
          label-position="left"
          label-width="115px"
          @submit.native.prevent
        >
          <!-- <el-row>
            <h2>标签信息</h2>
          </el-row>-->
          <el-row>
            <el-form-item label="标签原材料" required style="margin-top:10px">
              <el-select
                v-model="label.material"
                filterable
                placeholder="请选择材料"
                style="width: 388px"
                @focus="getMaterialHead"
              >
                <el-option
                  v-for="item in materialData"
                  :key="item.toString()"
                  :label="item.toString()"
                  :value="item.toString()"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row v-if="label.customer!='*'">
            <el-form-item label="客户" required>
              <el-select
                v-model="label.customer"
                filterable
                placeholder="请选择客户"
                style="width: 388px"
                @focus="getCustomers"
              >
                <el-option
                  v-for="item in customers"
                  :key="item.toString()"
                  :label="item.toString()"
                  :value="item.toString()"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-form-item label="客户使用编号">
            <el-tooltip class="item" effect="dark" content="客户料号 或者 客户图编号" placement="bottom-end">
              <el-input v-model="label.customerMaterial"></el-input>
            </el-tooltip>
          </el-form-item>
          <el-row></el-row>
          <el-row>
            <el-form-item label="黑标">
              <el-tooltip class="item" effect="dark" content="标签是否有黑标, 黑标类型" placement="bottom-end">
                <el-input v-model="label.black"></el-input>
              </el-tooltip>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="标签长(mm)" required>
                <el-input-number
                  size="small"
                  v-model="label.lbLength"
                  :precision="2"
                  :step="0.1"
                  :min="0"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="角型R(mm)" required>
                <el-tooltip class="item" effect="dark" placement="bottom-end">
                  <div slot="content">
                    常用刀模角型：R1.5
                    <br />方框较小的：R1
                    <br />最接近直角的：R0.5
                    <br />如果没有特殊要求标注（小圆角）都按现有刀模做
                  </div>
                  <el-input-number
                    size="small"
                    v-model="label.angle"
                    :precision="1"
                    :step="0.1"
                    :min="0"
                  ></el-input-number>
                </el-tooltip>
              </el-form-item>
              <el-form-item label="上下间距(mm)" required>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="张与张之间距，常规为2MM有虚刀的3MM"
                  placement="bottom-end"
                >
                  <el-input-number
                    size="small"
                    v-model="label.vSpacing"
                    :precision="1"
                    :step="0.1"
                    :min="0"
                  ></el-input-number>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="标签高(mm)" required>
                <el-input-number
                  size="small"
                  v-model="label.lbWidth"
                  :precision="2"
                  :step="0.1"
                  :min="0"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="圆孔内径(mm)" required>
                <el-tooltip class="item" effect="dark" placement="bottom-end">
                  <div slot="content">有圆孔的订单请备注孔直径与位置</div>
                  <el-input-number
                    size="small"
                    v-model="label.hole"
                    :precision="1"
                    :step="0.1"
                    :min="0"
                  ></el-input-number>
                </el-tooltip>
              </el-form-item>
              <el-form-item label="左右间距(mm)" required>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="排与排间距，单排的写无，双排以上没有特殊要求的写2MM"
                  placement="bottom-end"
                >
                  <el-input-number
                    size="small"
                    v-model="label.hSpacing"
                    :precision="1"
                    :step="0.1"
                    :min="0"
                  ></el-input-number>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="标签排数" required>
                <el-input-number size="small" v-model="label.row" :precision="0" :step="1" :min="1"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="刀具信息:">
                <el-checkbox v-model="label.dashed">虚刀</el-checkbox>
                <el-checkbox v-model="label.cut">切刀</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="左边距(mm)" required>
              <el-input-number
                size="small"
                v-model="label.leftBorderMin"
                :precision="1"
                :step="0.1"
                :min="0"
                :max="label.leftBorderMax"
                style="width: 150px"
              ></el-input-number>
              <span style="margin:0px 10px 0px 10px">~</span>
              <el-input-number
                size="small"
                v-model="label.leftBorderMax"
                :precision="1"
                :step="0.1"
                :min="label.leftBorderMin"
                style="width: 150px"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="右边距(mm)" required>
              <el-input-number
                size="small"
                v-model="label.rightBorderMin"
                :precision="1"
                :step="0.1"
                :min="0"
                :max="label.rightBorderMax"
                style="width: 150px"
              ></el-input-number>
              <span style="margin:0px 10px 0px 10px">~</span>
              <el-input-number
                size="small"
                v-model="label.rightBorderMax"
                :precision="1"
                :step="0.1"
                :min="label.rightBorderMin"
                style="width: 150px"
              ></el-input-number>
            </el-form-item>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      materialData: [],
      salesmen: [],
      customers: []
    };
  },
  props: {
    order: {},
    label: {},
    disabled: Boolean
    // customer: Array
  },
  created: function() {
    this.getSalesMen();
  },
  methods: {
    getMaterialHead: async function() {
      var res = await this.$doGet("/api/basedata/materialhead");
      if (res.msgCode == 0) {
        this.materialData = res.result.infos;
      } else {
        this.$message.error(res.msg);
      }
    },
    getSalesMen: async function() {
      var res = await this.$doGet("/api/basedata/salesmen");
      if (res.msgCode == 0) {
        this.salesmen = res.result.infos;
      } else {
        this.$message.error(res.msg);
      }
    },
    getCustomers: async function() {
      let message = await this.$doGet("/api/basedata/customer");
      if (message.msgCode == 0) {
        this.customers = message.result.infos;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/production/OrderInfo.vue